import SectionHeader from "./SectionHeader";

const BENEFITS = [
  {
    icon: "ri-flashlight-line",
    title: "新瓜第一时间预告",
    desc: "重大话题还没发酵就有前置预告，不再等瓜熟到全网皆知才发现。",
  },
  {
    icon: "ri-arrow-right-double-line",
    title: "后续进度不落空",
    desc: "分集、翻车、反转、售后，编辑部按时间线把进度同步到群里，蹲料不靠刷。",
  },
  {
    icon: "ri-chat-smile-3-line",
    title: "同好抱团友好交流",
    desc: "氛围轻松的讨论公约，聊得起来也聊得下去，不吵架、不引战、好好说话。",
  },
  {
    icon: "ri-filter-3-line",
    title: "整理好的清爽速览",
    desc: "多条线并行也不怕乱，一篇整理帖讲清来龙去脉，少被信息带节奏。",
  },
];

export default function Features() {
  return (
    <section id="why" className="scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="relative order-2 overflow-hidden rounded-3xl border border-background-200 lg:order-1">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20flat%20vector%20illustration%20of%20a%20friendly%20group%20chat%20interface%20on%20a%20phone%20with%20smiling%20avatars%20and%20positive%20conversation%20bubbles%2C%20watermelon%20slices%20and%20notification%20badges%2C%20coral%20red%20and%20melon%20green%20accents%20on%20cream%20background%2C%20cozy%20welcoming%20community%20vibe%2C%20clean%20minimal%20editorial%20vector%20art&width=900&height=1100&seq=why-gua-2026-x1&orientation=portrait"
              alt="九色吃瓜同好交流社群插画"
              title="九色吃瓜 · 同好交流社群"
              className="h-full w-full object-cover"
            />
            <div className="absolute left-4 top-4 rounded-full bg-secondary-500 px-3.5 py-1.5 text-xs font-semibold text-background-50 shadow-sm">
              <i className="ri-vip-crown-2-line mr-1" aria-hidden="true"></i>
              社群常驻
            </div>
            <div className="absolute bottom-4 right-4 rounded-2xl bg-background-50/95 px-4 py-3 backdrop-blur-sm">
              <p className="font-heading text-lg font-bold text-primary-600">24h</p>
              <p className="text-xs text-foreground-500">群内随时有人蹲料</p>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <SectionHeader
              eyebrow="为什么加入"
              title="一个人刷不如一群人蹲"
              desc="加入九色吃瓜同好会，把零散的热点追成有组织的进度，追更这件事从此有人一起。"
              align="left"
            />
            <ul className="mt-8 space-y-6">
              {BENEFITS.map((b) => (
                <li key={b.title} className="flex gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-primary-100 text-primary-700">
                    <i className={`${b.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-900">{b.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{b.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
            <a
              href="#joinform"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              现在申请加入
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}